export default {
    GET_PAYMENT_PAYPAL : '[SETTING] GET_PAYMENT_PAYPAL',
    GET_PAYMENT_BAMBORA: '[SETTING] GET_PAYMENT_BAMBORA',
    GET_PAYMENT_TYRO   : '[SETTING] GET_PAYMENT_TYRO',
}



// WEBPACK FOOTER //
// ./src/view/constant/settings/PaymentConstant.js